import CryptoJS from "crypto-js";

export const aes128SecretKey = "eypasssnkichanjinu20220519754988"; // key 값 16 바이트
export const aes128Iv = "eyhy2022qpalzm!@"; //iv 16 바이트

/**
 * AES 암호화
 * @param {string} str 암호화 대상 문자열
 * @return {string} 암호화된 결과 문자열
 */
export function AESEncrypt(str) {
    const secretKey = CryptoJS.enc.Utf8.parse(aes128SecretKey);
    const iv = CryptoJS.enc.Utf8.parse("1234567812345678");
    const encrypted = CryptoJS.AES.encrypt(str, secretKey, {
        iv,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

/**
 * AES 복호화
 * @param {string} str 복호화 대상 문자열
 * @return {string} 복호화된 결과 문자열
 */
export function AESDecrypt(str) {
    const secretKey = CryptoJS.enc.Utf8.parse(aes128SecretKey);
    const iv = CryptoJS.enc.Utf8.parse("1234567812345678");
    const encrypted = CryptoJS.AES.decrypt(str.toString(), secretKey, {
        iv,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString(CryptoJS.enc.Utf8);
}
